<template>
	<div :id="name" :class="classes">
		<Piece v-for="i in 3" :key="i" :hidden="i === held + 1 && noneHeld" ref="pieces"/>
		<template v-for="(row, y) in board" :key="y">
			<Block v-for="(x, i) in filledBlocks(row)" :key="i" :pos="{x: x, y: y}"/>
		</template>
	</div>
</template>

<script>
import Piece from './Piece.vue'
import Block from './Block.vue'
import { computed } from 'vue'

export default {
	name: 'Board',
	components: {
		Piece,
		Block,
	},
	props: {
		paused: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			name: 'board',
			board: [],
			active: 0,
			held: 1,
			next: 2,
			noneHeld: true,
			pos: {
				x: 0,
				y: 0,
			},
		}
	},
	provide() {
		return { board: computed(() => this.board) }
	},
	methods: {
		clearBoard() {
			this.board = new Array(22)
			for (let i = 0; i < this.board.length; i++) {
				this.board[i] = this.emptyRow()
			}
			this.$nextTick(() => this.$refs.pieces[this.active].activate())
		},
		emptyRow() {
			return new Array(10).fill(false)
		},
		calcPos() {
			const rect = this.$el.getBoundingClientRect()
			this.pos = {
				x: rect.x,
				y: rect.y,
			}
		},
		move(event) {
			this.$refs.pieces[this.active].move(event.detail)
		},
		drop() {
			this.$refs.pieces[this.active].drop()
		},
		hold() {
			this.$refs.pieces[this.active].hold()
			if (this.noneHeld) {
				const tmp = this.active
				this.active = this.next
				this.next = this.held
				this.held = tmp
				this.noneHeld = false
			} else {
				const tmp = this.active
				this.active = this.held
				this.held = tmp
			}
			this.$refs.pieces[this.active].activate()
		},
		tick() {
			this.$refs.pieces[this.active].tick()
		},
		collect(event) {
			const filledRows = []
			event.detail.blocks.forEach(block => {
				const { x, y } = block.pos
				this.board[y][x] = true
				if (this.checkRow(y)) {
					filledRows.push(y)
				}
			})
			filledRows.sort((a, b) => b - a).forEach(y => {
				this.board.splice(y, 1)
			})
			while (this.board.length < 22) {
				this.board.unshift(this.emptyRow())
			}
			const tmp = this.active
			this.active = this.next
			this.next = tmp
			this.$refs.pieces[this.active].activate()
			this.$refs.pieces[this.next].reset(this.$refs.pieces[this.active].type)
		},
		checkRow(y) {
			for (let x = 0; x < this.board[y].length; x++) {
				if (!this.board[y][x]) return false
			}
			return true
		},
		filledBlocks(_row) {
			const row = []
			for (let x = 0; x < _row.length; x++) {
				if (_row[x]) row.push(x)
			}
			return row
		},
	},
	computed: {
		classes() {
			return [
				this.name,
				{ [`${this.name}--paused`]: this.paused },
			]
		},
	},
	mounted() {
		this.clearBoard()
		this.calcPos()
		window.addEventListener('resize', this.calcPos)
		this.$root.$el.addEventListener('move', this.move)
		this.$root.$el.addEventListener('drop', this.drop)
		this.$root.$el.addEventListener('hold', this.hold)
		this.$root.$el.addEventListener('tick', this.tick)
		this.$root.$el.addEventListener('release', this.collect)
	},
	unmounted() {
		window.removeEventListener('resize', this.calcPos)
		this.$root.$el.removeEventListener('move', this.move)
		this.$root.$el.removeEventListener('drop', this.drop)
		this.$root.$el.removeEventListener('hold', this.hold)
		this.$root.$el.removeEventListener('release', this.collect)
	},
}
</script>

<style lang="scss">
.board {
	width: calc($block-size * 10);
	height: calc($block-size * 22);
	margin: auto;
	background-color: #00000033;
	position: relative;
	// overflow-y: hidden;

	&--paused {
		filter: blur(5px);
		cursor: pointer;
	}
}
</style>
